<template>
    <div class="GsAppCompont_Commont">
        <div class="Commont-hot">
            <!-- 无评论 -->
            <template
                v-if="
                    (GetCommentsList.length == 1 ||
                        (GetCommentsList.length ==
                            ($utils.browser.isiOS() ? 1 : 2) &&
                            type == 'duanPing')) &&
                        loadType == 4
                "
            >
                <template v-if="type == 'xinWen'">
                    <div class="Commont-TitleBox">
                        <div class="Commont-title">全部评论</div>
                    </div>
                    <!-- <img class="Commont-Wupinglun-pic" src="//image.gamersky.com/app/icons6.0/image_Wupinglun.png" /> -->
                    <div class="Commont-Wupinglun-pic"></div>
                </template>
                <p v-else class="Commont-WuPingCe-text">
                    {{
                        `暂无内容，去发表${
                            type == "duanPing" ? "短评" : "长评"
                        }吧~`
                    }}{{ GetCommentsList.length }}
                </p>
            </template>
            <!-- 有评论 -->
            <template v-else>
                <template v-for="(item, index) in GetCommentsList">
                    <div
                        class="Commont-TitleBox"
                        v-if="
                            (item.type == 'biaoTiLan' ||
                                item.type == 'caoZuoBiaoTiLan') &&
                                type == 'xinWen'
                        "
                        :key="'commont' + index"
                    >
                        <div class="Commont-title">{{ item.title }}</div>
                        <div class="Commont-sort" @click="GetCommentOrder()">
                            <div class="Commont-sortName">推荐</div>
                            <div class="Commont-sortName">最新</div>
                            <div
                                class="Commont-sortCur"
                                :class="{ cur: CommentOrder != 'tuiJian' }"
                            >
                                {{
                                    CommentOrder == "tuiJian" ? "推荐" : "最新"
                                }}
                            </div>
                        </div>
                    </div>
                    <!-- 标签按钮条 -->
                    <template v-else-if="item.type == 'biaoTiLan'">
                        <div
                            class="Commont-Review-btnWrap"
                            :key="'biaoQianAnNiu' + index"
                        >
                            <div
                                v-show="
                                    item.buttonInfes &&
                                        item.buttonInfes.length > 0
                                "
                                class="Commont-Review-btnBox"
                                :key="'biaoQianAnNiu1' + index"
                            >
                                <div class="Commont-Review-btnList">
                                    <a
                                        class="Commont-Review-btnItem"
                                        :href="biaoQian.contentUrl"
                                        target="_blank"
                                        v-for="biaoQian in item.buttonInfes"
                                        :key="biaoQian.caption"
                                    >
                                        {{ biaoQian.caption }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template
                        v-else-if="
                            item.type == 'pingLun' ||
                                item.type == 'pingLun_YouXiDuanPing' ||
                                item.type == 'tieZi' ||
                                item.type == 'woDe_YongHuTieZi_YouXiChangPing'
                        "
                    >
                        <div
                            class="Commont-detailBox"
                            :key="'commont' + index"
                            :commontIndex="index"
                        >
                            <div class="Commont-Top">
                                <!-- 用户头像 -->
                                <div
                                    class="Commont-HeadImage"
                                    @click="
                                        PersonalCenterInto(
                                            item.commentInfo.user.id
                                        )
                                    "
                                >
                                    <template>
                                        <img
                                            v-if="
                                                item.commentInfo &&
                                                    item.commentInfo.user &&
                                                    item.commentInfo.user
                                                        .headImageUrl
                                            "
                                            :src="
                                                item.commentInfo.user
                                                    .headImageUrl
                                            "
                                        />
                                        <div
                                            v-else
                                            class="Commont-NotHeadImage"
                                        ></div>
                                    </template>

                                    <template
                                        v-if="
                                            item.userInfo &&
                                                item.userInfo.userItems &&
                                                item.userInfo.userItems.length >
                                                    0
                                        "
                                    >
                                        <template
                                            v-for="(f, fi) in item.userInfo
                                                .userItems"
                                        >
                                            <!-- :style="{'background-image': 'url('+  +')'}" -->
                                            <div
                                                v-if="f.type == 'avatar_box'"
                                                :key="'f' + fi"
                                                class="Commont-AvatarFrame"
                                                :data-avatarFrames="
                                                    f.avatarBoxUrls
                                                "
                                            >
                                                <div
                                                    class="Commont-AvatarFrameList"
                                                    style="display: none"
                                                >
                                                    <img
                                                        v-for="(ab,
                                                        abIndex) in f.avatarBoxUrls"
                                                        :key="'ab' + abIndex"
                                                        :src="ab"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <!-- 当前用户信息 -->
                                <div
                                    class="Commont-Information"
                                    v-if="
                                        item.commentInfo &&
                                            item.commentInfo.user
                                    "
                                >
                                    <div class="Commont-InformationBox">
                                        <span
                                            class="Commont-Name gs-ellipsis2"
                                            :style="handleEllipsis(item, index)"
                                            :class="handleUserNameColor(item)"
                                            @click="
                                                PersonalCenterInto(
                                                    item.commentInfo.user.id
                                                )
                                            "
                                            >{{
                                                item.commentInfo.user.name
                                            }}</span
                                        >
                                        <i
                                            class="Commont-isRealPlayer"
                                            v-show="
                                                item.commentInfo.user
                                                    .isRealPlayer
                                            "
                                            @click="
                                                PersonalCenterInto(
                                                    item.commentInfo.user.id
                                                )
                                            "
                                        ></i>
                                        <img
                                            class="Commont-badge"
                                            v-if="
                                                type != 'duanPing' &&
                                                    type != 'pingCe' &&
                                                    badgeIdInfos[
                                                        item.commentInfo.user.id
                                                    ]
                                            "
                                            :src="
                                                badgeImgUrls[
                                                    item.commentInfo.user.id
                                                ] != 0
                                                    ? badgeImgUrls[
                                                          item.commentInfo.user
                                                              .id
                                                      ]
                                                    : ''
                                            "
                                            :idIndex="
                                                index +
                                                    '_' +
                                                    badgeImgUrl[index] +
                                                    '_' +
                                                    badgeIdInfo[index]
                                            "
                                            @click="
                                                BadgeCenterInto(
                                                    item.commentInfo.user.id,
                                                    badgeIds[
                                                        item.commentInfo.user.id
                                                    ],
                                                    badgeLevels[
                                                        item.commentInfo.user.id
                                                    ]
                                                )
                                            "
                                        />
                                        <span
                                            class="Commont-Level"
                                            :style="
                                                setLevel(
                                                    item.commentInfo.user.level
                                                )
                                            "
                                            @click="
                                                PersonalCenterInto(
                                                    item.commentInfo.user.id
                                                )
                                            "
                                        ></span>
                                    </div>
                                    <div class="Commont-Fraction">
                                        <span
                                            v-if="
                                                type == 'xinWen' &&
                                                    CommentOrder != 'tuiJian'
                                            "
                                            >{{
                                                item.commentInfo.number
                                            }}楼</span
                                        >
                                        <div
                                            class="Commont-FractionBox"
                                            v-if="
                                                (type == 'duanPing' ||
                                                    type == 'pingCe') &&
                                                    item.commentInfo.gameLabelCaption.indexOf(
                                                        '玩过'
                                                    ) > -1
                                            "
                                        >
                                            <div
                                                :class="[
                                                    `${
                                                        item.commentInfo
                                                            .contentScore
                                                            ? 'star' +
                                                              Math.floor(
                                                                  item
                                                                      .commentInfo
                                                                      .contentScore /
                                                                      2
                                                              )
                                                            : 'star0'
                                                    }`,
                                                ]"
                                            ></div>
                                        </div>
                                        <span
                                            v-if="
                                                type == 'duanPing' ||
                                                    type == 'pingCe'
                                            "
                                            >{{
                                                item.commentInfo
                                                    .gameLabelCaption
                                            }}</span
                                        >
                                        <span
                                            class="commentInfo"
                                            style="max-height:16px;max-width:95px;flex-shrink:0"
                                            >{{
                                                item.commentInfo
                                                    .publishTimeCaption
                                            }}</span
                                        >
                                        <span
                                            v-if="
                                                type != 'duanPing' &&
                                                    type != 'pingCe' &&
                                                    item.commentInfo.ipLocation
                                            "
                                            class="commentInfo"
                                            style="max-height:16px;max-width:170px;flex-shrink:0"
                                            >来自{{
                                                item.commentInfo.ipLocation
                                            }}</span
                                        >
                                        <span
                                            class="commentInfo"
                                            v-show="item.commentInfo.deviceName"
                                            style="max-width:127px;max-height:16px"
                                            >{{
                                                item.commentInfo.deviceName
                                            }}</span
                                        >
                                        <!-- <span class="commentInfo" style="max-height:16px;max-width:270px;flex-shrink:0;">{{ item.commentInfo.publishTimeCaption + "  " + "来自" + item.commentInfo.ipLocation}}</span>
                                        <span class="commentInfo" v-show="item.commentInfo.deviceName" style="max-width:127px;max-height:16px;">{{
                                            item.commentInfo.deviceName
                                        }}</span> -->
                                    </div>
                                </div>
                                <!-- 评论点赞按钮 -->
                                <!-- 增加踩按钮 -->
                                <span
                                    v-if="type == 'xinWen'"
                                    class="Commont-options"
                                >
                                    <span
                                        class="Commont-zan"
                                        @click="
                                            praiseComment2(
                                                item.commentInfo.id,
                                                $event,
                                                null,
                                                item,
                                                index
                                            )
                                        "
                                        :class="{ cur: item.zanStatus }"
                                        ><i></i>
                                        <span>{{
                                            item.commentInfo.praisesCount
                                        }}</span>
                                    </span>
                                    <span
                                        v-if="versionShow"
                                        class="Commont-cai"
                                        :class="{ cur: item.caiStatus }"
                                        @click.stop="
                                            treadComment(
                                                item,
                                                $event,
                                                item.commentInfo,
                                                index
                                            )
                                        "
                                    >
                                        <i></i>
                                    </span>
                                </span>

                                <!-- 更多操作 -->
                                <span
                                    class="Commont-more"
                                    v-else
                                ></span>
                            </div>

                            <div v-if="item.title" class="Commont-Title">
                                {{ item.title }}
                            </div>

                            <div
                                class="Commont-detail"
                                :itemData="JSON.stringify(item)"
                                :style="{
                                    paddingLeft:
                                        type == 'xinWen' ? '46px' : '0',
                                }"
                            >
                                <!-- 当前用户评论内容 -->
                                <div
                                    class="Commont-Text"
                                    lineHeight="6"
                                    v-show="
                                        item.commentInfo.contentInHtml != ''
                                    "
                                >
                                    <div
                                        v-html="
                                            replaceEmoji(
                                                item.commentInfo.contentInHtml
                                            )
                                        "
                                        class="Commont-desc"
                                        :class="{
                                            blocked_user_comment:
                                                item.currentUserContentRelation &&
                                                item.currentUserContentRelation
                                                    .beBlock,
                                            pingCeText: type == 'pingCe',
                                        }"
                                    ></div>
                                    <span
                                        class="Commont-Unfold"
                                        style="display: none"
                                        >...<a
                                            href="javascript:;"
                                            @click.self.stop="openText($event)"
                                            >展开</a
                                        ></span
                                    >
                                </div>

                                <!-- 当前用户评论图片   && !item.postInfo.videoThumbnailURL-->
                                <div
                                    class="Commont-ImageInfes"
                                    :class="{
                                        'Commont-TieZi':
                                            type == 'pingCe' ||
                                            type == 'changPing',
                                    }"
                                    v-if="
                                        item.commentInfo.imageInfes &&
                                            item.commentInfo.imageInfes.length >
                                                0 &&
                                            (!item.postInfo ||
                                                !item.postInfo.videoOriginURL)
                                    "
                                >
                                    <div
                                        class="Commont-ImageInfes-Length"
                                        v-if="
                                            item.commentInfo.imageInfes.length >
                                                0 &&
                                                item.commentInfo.imageInfes
                                                    .length >
                                                    (item.type ==
                                                        'woDe_YongHuTieZi_YouXiChangPing' ||
                                                    item.type ==
                                                        'pingLun_YouXiDuanPing'
                                                        ? 3
                                                        : 9)
                                        "
                                    >
                                        共{{
                                            item.commentInfo.imageInfes.length
                                        }}图
                                    </div>

                                    <div
                                        class="Commont-ImageInfesFrame"
                                        :class="{
                                            CommentStyle:
                                                type != 'pingCe' &&
                                                type != 'changPing',
                                        }"
                                    >
                                        <template
                                            v-for="(ImageInfo,
                                            ImageInfoIndex) in item.commentInfo
                                                .imageInfes"
                                        >
                                            <div
                                                class="Commont-ImageInfes-Item"
                                                :key="ImageInfoIndex"
                                                @click.stop="
                                                    viewPicture(
                                                        ImageInfoIndex,
                                                        $event
                                                    )
                                                "
                                                v-if="
                                                    ImageInfoIndex <
                                                        (item.type ==
                                                            'woDe_YongHuTieZi_YouXiChangPing' ||
                                                        item.type ==
                                                            'pingLun_YouXiDuanPing'
                                                            ? 3
                                                            : 9)
                                                "
                                            >
                                                <img
                                                    :contentImageUrl="
                                                        ImageInfo.contentImageUrl
                                                    "
                                                    :sourceImageUrl="
                                                        ImageInfo.sourceImageUrl
                                                    "
                                                    :imageWidth="
                                                        ImageInfo.imageWidth
                                                    "
                                                    :imageHeight="
                                                        ImageInfo.imageHeight
                                                    "
                                                    :src="
                                                        ImageInfo.listImageUrl
                                                    "
                                                />
                                                <i
                                                    :class="
                                                        imageTag(
                                                            ImageInfo
                                                                .imageTags[0]
                                                        )
                                                    "
                                                    v-if="
                                                        ImageInfo.imageTags &&
                                                            ImageInfo.imageTags
                                                                .length > 0
                                                    "
                                                ></i>
                                            </div>
                                        </template>
                                    </div>
                                </div>

                                <!-- 当前用户评论视频 -->
                                <div
                                    class="Commont-VideoInfes"
                                    v-if="
                                        item.postInfo &&
                                            item.postInfo.videoOriginURL
                                    "
                                >
                                    <img
                                        :src="item.postInfo.videoThumbnailURL"
                                        alt=""
                                    />
                                    <i></i>
                                </div>

                                <!-- 当前用户评论时间 点赞等 -->
                                <div
                                    class="Commont-Footer"
                                    v-if="
                                        type == 'duanPing' || type == 'pingCe'
                                    "
                                >
                                    <div class="Commont-Footer-Left"></div>
                                    <div class="Commont-Footer-Right">
                                        <span
                                            class="Commont-replies"
                                            ><i></i
                                            ><span>{{
                                                item.commentInfo.repliesCount
                                            }}</span></span
                                        >
                                        <span
                                            class="Commont-zan"
                                            @click.stop="
                                                praiseComment(
                                                    item.id,
                                                    $event,
                                                    item.contentUrl
                                                        ? item.contentUrl
                                                        : '',
                                                    item,
                                                    index
                                                )
                                            "
                                            :class="{ cur: item.zanStatus }"
                                            ><i></i
                                            ><span>{{
                                                item.commentInfo.praisesCount
                                            }}</span></span
                                        >
                                        <span
                                            class="Commont-cai"
                                            @click.stop="
                                                treadContent(
                                                    item.contentUrl,
                                                    $event
                                                )
                                            "
                                            ><i></i
                                        ></span>
                                    </div>
                                </div>
                                <!-- 回复用户模块 -->
                                <template
                                    v-if="
                                        item.commentInfo.replies &&
                                            item.commentInfo.replies.length >
                                                0 &&
                                            type == 'xinWen'
                                    "
                                >
                                    <div
                                        class="Commont-replyBox"
                                        :itemData="JSON.stringify(item)"
                                    >
                                        <div
                                            class="Commont-reply"
                                            :style="[
                                                {
                                                    display:
                                                        replyIndex > 1
                                                            ? 'none'
                                                            : 'block',
                                                },
                                            ]"
                                            :itemData="JSON.stringify(reply)"
                                            v-for="(reply, replyIndex) in item
                                                .commentInfo.replies"
                                            :key="'replies' + replyIndex"
                                        >
                                            <div class="Commont-Information">
                                                <div
                                                    class="Commont-HeadImage"
                                                    @click="
                                                        PersonalCenterInto(
                                                            reply.user.id
                                                        )
                                                    "
                                                >
                                                    <img
                                                        :src="
                                                            reply.user
                                                                .headImageUrl
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    class="Commont-InformationBox"
                                                >
                                                    <span class="Commont-Name"
                                                        ><span
                                                            class="gs-ellipsis2"
                                                            :class="{
                                                                'gs-ellipsis':
                                                                    item.userInfo &&
                                                                    reply.replyUser &&
                                                                    reply
                                                                        .replyUser
                                                                        .name !=
                                                                        item
                                                                            .userInfo
                                                                            .name,
                                                            }"
                                                            :style="
                                                                handleEllipsis(
                                                                    item,
                                                                    replyIndex,
                                                                    reply
                                                                )
                                                            "
                                                            @click.stop="
                                                                PersonalCenterInto(
                                                                    reply.user
                                                                        .id
                                                                )
                                                            "
                                                            >{{
                                                                reply.user.name
                                                            }}
                                                        </span>

                                                        <template
                                                            v-if="
                                                                item.userInfo &&
                                                                    reply.replyUser &&
                                                                    reply
                                                                        .replyUser
                                                                        .name !=
                                                                        item
                                                                            .userInfo
                                                                            .name
                                                            "
                                                        >
                                                            <i class="gamersky triggle"
                                                                ></i
                                                            ><span
                                                                class="gs-ellipsis"
                                                                :style="
                                                                    handleEllipsis(
                                                                        item,
                                                                        replyIndex,
                                                                        reply
                                                                    )
                                                                "
                                                                @click.stop="
                                                                    PersonalCenterInto(
                                                                        reply
                                                                            .replyUser
                                                                            .id
                                                                    )
                                                                "
                                                                >{{
                                                                    reply
                                                                        .replyUser
                                                                        .name
                                                                }}</span
                                                            >
                                                        </template>
                                                    </span>
                                                    <span
                                                        class="commentInfo"
                                                        @click="
                                                            PersonalCenterInto(
                                                                reply.user.id
                                                            )
                                                        "
                                                        style="max-width:230px;max-height:16px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden"
                                                    >
                                                        <span
                                                            style="margin-right: 8pt;"
                                                            >{{
                                                                reply.publishTimeCaption
                                                            }}</span
                                                        >
                                                        <span
                                                            v-if="
                                                                reply.ipLocation
                                                            "
                                                            style="margin-right: 8pt;"
                                                            >{{
                                                                reply.ipLocation
                                                                    ? "来自" +
                                                                      reply.ipLocation
                                                                    : ""
                                                            }}</span
                                                        >
                                                        <span>{{
                                                            reply.deviceName
                                                                ? reply.deviceName
                                                                : ""
                                                        }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                class="Commont-Text"
                                                lineHeight="3"
                                            >
                                                <div
                                                    class="Commont-desc"
                                                    v-html="
                                                        replaceEmoji(
                                                            reply.contentInHtml
                                                        )
                                                    "
                                                    :class="{
                                                        blocked_user_comment:
                                                            reply.currentUserContentRelation &&
                                                            reply
                                                                .currentUserContentRelation
                                                                .beBlock,
                                                    }"
                                                ></div>
                                                <span
                                                    class="Commont-Unfold"
                                                    style="display: none"
                                                    >...<a
                                                        href="javascript:;"
                                                        @click.self.stop="
                                                            openText($event)
                                                        "
                                                        >展开</a
                                                    ></span
                                                >
                                            </div>
                                            <span class="Commont-options">
                                                <span
                                                    class="Commont-zan"
                                                    @click="
                                                        praiseComment2(
                                                            reply.id,
                                                            $event,
                                                            null,
                                                            reply,
                                                            index,
                                                            replyIndex
                                                        )
                                                    "
                                                    :class="{
                                                        cur: reply.zanStatus,
                                                    }"
                                                    ><i></i
                                                    ><span>{{
                                                        reply.praisesCount
                                                    }}</span></span
                                                >
                                                <span
                                                    v-if="versionShow"
                                                    class="Commont-cai"
                                                    :class="{
                                                        cur: reply.caiStatus,
                                                    }"
                                                    @click.stop="
                                                        treadComment(
                                                            reply,
                                                            $event,
                                                            reply,
                                                            index,
                                                            replyIndex
                                                        )
                                                    "
                                                    ><i></i
                                                ></span>
                                            </span>
                                        </div>
                                        <a
                                            href="javascript:;"
                                            class="Commont-MoreUnfold"
                                            v-show="
                                                item.commentInfo.replies
                                                    .length > 2
                                            "
                                            @click="MoreUnfold($event)"
                                            >展开{{
                                                item.commentInfo.replies
                                                    .length - 2
                                            }}条回复<i></i
                                        ></a>
                                    </div>
                                </template>
                            </div>
                            <gs-app-compont-hr
                                marginBottom="0"
                                v-if="type == 'duanPing' || type == 'pingCe'"
                            ></gs-app-compont-hr>
                        </div>
                    </template>
                </template>

                <div class="the-end" v-show="loadType == 4"></div>
                <div class="the-more" v-show="loadType == 1 || loadType == 2">
                    <i></i>正在加载
                </div>
                <!-- 结束 -->
            </template>
        </div>
    </div>
</template>

<script>
import "../assets/js/directive";
import GsAppCompontHr from "./GsAppCompont_Hr";
import config from "../assets/config/index.js";
import utils from "../assets/js/utils";


export default {
    name: "GsAppCompontCommont",
    components: { GsAppCompontHr },
    props: {
        type: {
            type: String,
            default: "xinWen",
        },
        pageSize: {
            type: [String, Number],
            default: 10,
        },
        topicId: {
            type: [String, Number],
            default: 0,
        },
    },
    data() {
        return {
            CommentOrder: "tuiJian", // tuiJian || faBuShiJianJiangXu
            GetCommentsList: [],
            PageIndex: 0,
            isAchiveBottom: false,
            fontNumber: 150,
            showEnd: false,
            showMore: false,
            isFirstPage: true,
            loadType: 1, // 1未加载 2加载中 3加载完成 4无内容
            commentIndex: 0,
            isSecondLevelReply: true,
            nicknameColor: "",
            avatarFrameIndex: 0,
            avatarFrameTimer: null,
            isLongpress: false,
            badgeIdInfo: [],
            badgeIdInfos: {},
            badgeImgUrl: [],
            badgeImgUrls: {},
            badgeId: [],
            badgeIds: {},
            badgeLevel: [],
            badgeLevels: {},
            versionShow: false,
            isFixed: false,
            contentInHtml: "",
            keyBoardShow: false,
            replyComment: {},
        };
    },
    watch: {
        commontId() {
            return this.$store.state.commontId;
        },
        sourceUrl() {
            return this.$store.state.sourceUrl;
        },
        GetCommentsList(val) {
            if (val.length > 0) {
                this.$nextTick(() => {
                    if (document.querySelectorAll(".Commont-Review-btnList")) {
                        var btnList = document.querySelectorAll(
                            ".Commont-Review-btnList"
                        );
                        for (let i = 0; i < btnList.length; i++) {
                            GSAppJsApi.UI.registerHorizontalScrollWithHtmlNode(
                                btnList[i]
                            );
                        }
                    }
                });
                // this.handleLabel();
            }
        },
    },
    mounted() {

        let that = this;
        this.GetComments();
        GSAppJsApi.Environment.getAppInfo(function(didReceiveAppInfo) {
            if (didReceiveAppInfo && didReceiveAppInfo.appVersion) {
                if (
                    utils.versionStringCompare(
                        didReceiveAppInfo.appVersion,
                        "6.6.0"
                    ) > -1
                ) {
                    that.versionShow = true;
                }
            }
        });
        this.loadType = 2;
        if (this.$store.state.sourceUrl != "" && this.type == "xinWen") {
            window.addEventListener("scroll", this.scroll);
        }
            window.document.documentElement.setAttribute("data-theme", 'Dark');

    },
    methods: {
        // 处理用户名截断
        handleEllipsis(item, index, reply) {
            let styleObj = {
                "max-width": "calc(100% - 140px)",
                background: "#333",
            };
            let otherWidth = 100;
            // 一级评论
            if (!reply && item.commentInfo) {
                // 徽章标识是否展示 占宽度26px
                if (
                    this.type != "duanPing" &&
                    this.type != "pingCe" &&
                    this.badgeIdInfo[index]
                ) {
                    otherWidth = otherWidth + 26;
                }
                // 玩过标识是否展示 占宽度20px
                if (item.commentInfo.user.isRealPlayer) {
                    otherWidth = otherWidth + 20;
                }
            } else {
                // 二级评论
                // 有回复用户的
                if (
                    item.userInfo &&
                    reply.replyUser &&
                    reply.replyUser.name != item.userInfo.name
                ) {
                    if (reply.is_author) {
                        return { "max-width": `calc(50% - 55px)` };
                    } else {
                        return { "max-width": `calc(50% - 45px)` };
                    }
                } else {
                    if (item.is_author) {
                        otherWidth = 102;
                    } else {
                        return {
                            "max-width": `calc(100% - 70px)`,
                            "margin-right": "4px",
                        };
                    }
                }
            }
            return { "max-width": `calc(100% - ${otherWidth}px)` };
        },

        // 处理红名
        handleUserNameColor(item) {
            let nicknameColor = "";
            if (
                item.userInfo &&
                item.userInfo.userItems &&
                item.userInfo.userItems.length > 0
            ) {
                let userItems = item.userInfo.userItems;
                userItems.forEach((p, i) => {
                    if (p.type == "colorful_nickname") {
                        nicknameColor = "HongMing";
                    }
                });
            }

            if (nicknameColor == "") {
                return "";
            } else {
                return "HongMing";
            }
        },
        // 处理头像框
        handleAvatarFrame() {
            let that = this;
            let avatarFrameList = document.querySelectorAll(
                ".Commont-AvatarFrame"
            );
            for (let i = 0; i < avatarFrameList.length; i++) {
                let imgList = avatarFrameList[i].getAttribute(
                    "data-avatarFrames"
                );
                imgList = imgList.split(",");
                if (imgList.length > 1) {
                    for (let j = 0; j < imgList.length; j++) {
                        let imgIndex = this.avatarFrameIndex % imgList.length;
                        if (imgIndex < 0) {
                            imgIndex *= -1;
                        }
                        avatarFrameList[i].setAttribute(
                            "style",
                            "background-image: url(" + imgList[imgIndex] + ")"
                        );
                    }
                }
            }
            this.avatarFrameIndex = this.avatarFrameIndex + 1;
        },
        calculateText(isGetCommentOrder = false) {
            let that = this;
            let dom = document.querySelector(".Commont-Text");
            if (!dom) {
                return;
            }
            let line = Number(dom.getAttribute("lineHeight"));
            let textHeight =
                Number(
                    window.getComputedStyle(dom).lineHeight.replace("px", "")
                ) * line;
            let domList = document.querySelectorAll(".Commont-Text");
            [].forEach.call(domList, (item) => {
                let textDom = item.querySelector("div");
                let unfoldDom = item.querySelector(".Commont-Unfold");
                if (textDom.getAttribute("isUnfold") == "true") {
                    return;
                }
                if (!isGetCommentOrder) {
                    if (unfoldDom.style.display == "inline") {
                        return;
                    }
                }

                let offsetHeight = textDom.offsetHeight;
                if (offsetHeight > textHeight) {
                    textDom.style.height = `${textHeight}px`;
                    unfoldDom.style.display = "inline";
                } else {
                    textDom.style.height = "auto";
                    unfoldDom.style.display = "none";
                }
            });
        },
        scroll() {
            let that = this;
            // 变量 scrollTop 是滚动条滚动时, 距离顶部的距离
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            // 变量 windowHeight 是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            // 变量 scrollHeight 是滚动条的总高度
            let scrollHeight =
                document.documentElement.scrollHeight ||
                document.body.scrollHeight;
            // 滚动条到底部的条件 (距底部 20px 时触发加载)
            if (
                scrollTop + windowHeight >= scrollHeight - 800 &&
                !that.isAchiveBottom &&
                !that.noMore
            ) {
                that.isAchiveBottom = true;
                that.GetComments();
            }
        },
        GetComments(sort = false) {
            let that = this;
            let sourceUrl = that.$store.state.sourceUrl;

            if (that.loadType == 1 || that.loadType == 3) {
                that.loadType = 2;
                let GetPingCeType =
                    that.type == "pingCe" || that.type == "changPing"
                        ? true
                        : false;
                let data = {
                    listName: GetPingCeType ? "游戏长评列表" : "评论列表",
                    contentUrl: sourceUrl,
                    order: that.CommentOrder,
                    pageIndex: that.PageIndex,
                    pageSize: that.pageSize,
                };
                if (that.type == "duanPing") {
                    data["isFilterConditionShow"] = true;
                }

                if (sourceUrl) {
                    that.showMore = true;
                    let Url = `//router.gamersky.com/@/lists/getListElements/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                    that.$ajax.post(Url, data).then((response) => {
                        that.showMore = false;
                        if (response && response.error == "") {
                            // 评论信息回调
                            let commontChangeData = {
                                isCommonts:
                                    response.listElements.length <= 1
                                        ? false
                                        : true,
                                CommontsCount:
                                    response.allListElementsCount || 0,
                                contentUrl: response.listElements[0]
                                    ? response.listElements[0].contentUrl
                                    : "",
                                CommontsLength:
                                    response.listElements.length || 0,
                            };
                            that.$emit("commontChange", commontChangeData);
                            if (response.listElements.length > 0) {
                                let isRender = true;
                                if (
                                    (response.listElements[0].type ==
                                        "biaoTiLan" ||
                                        response.listElements[0].type ==
                                            "caoZuoBiaoTiLan") &&
                                    !that.isFirstPage &&
                                    !sort
                                ) {
                                    isRender = false;
                                }
                                if (isRender) {
                                } else {
                                    that.showEnd = true;
                                }

                                that.isFirstPage = false;
                                let userId = response.listElements.map((item) =>
                                    JSON.stringify(item.authorUserId)
                                );
                                let userIds = [];
                                userId.forEach((value) => {
                                    userIds.push(value);
                                });
                                // userIds = userIds
                                that.$ajax
                                    .post(
                                        "//router.gamersky.com/@/userData/asset/user/list",
                                        { userIds: userIds }
                                    )
                                    .then((data) => {
                                        console.log("data", data);
                                        data["data"] = data;
                                        for (
                                            let i = 0;
                                            i <
                                            data.data.infoList
                                                .userVirtualAssetInfoLists
                                                .length;
                                            i++
                                        ) {
                                            if (
                                                data.data.infoList
                                                    .userVirtualAssetInfoLists[
                                                    i
                                                ].userAssetViewList.length == 0
                                            ) {
                                                that.badgeIdInfo.push(false);
                                                that.badgeIdInfos[
                                                    data.data.infoList.userVirtualAssetInfoLists[
                                                        i
                                                    ].userId
                                                ] = false;
                                                that.badgeImgUrl.push("0");
                                                that.badgeId.push(0);
                                                that.badgeLevel.push(0);
                                                that.badgeImgUrls[
                                                    data.data.infoList.userVirtualAssetInfoLists[
                                                        i
                                                    ].userId
                                                ] = "";
                                                that.badgeIds[
                                                    data.data.infoList.userVirtualAssetInfoLists[
                                                        i
                                                    ].userId
                                                ] = "";
                                                that.badgeLevels[
                                                    data.data.infoList.userVirtualAssetInfoLists[
                                                        i
                                                    ].userId
                                                ] = "";
                                            } else if (
                                                data.data.infoList
                                                    .userVirtualAssetInfoLists[
                                                    i
                                                ].userAssetViewList[0] != 0
                                            ) {
                                                if (
                                                    data.data.infoList
                                                        .userVirtualAssetInfoLists[
                                                        i
                                                    ].userAssetViewList
                                                        .length == 1
                                                ) {
                                                    if (
                                                        data.data.infoList
                                                            .userVirtualAssetInfoLists[
                                                            i
                                                        ].userAssetViewList[0]
                                                            .type == "badge"
                                                    ) {
                                                        that.badgeIdInfo.push(
                                                            true
                                                        );
                                                        that.badgeIdInfos[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = true;
                                                        that.badgeImgUrl.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[0]
                                                                .smallImageUrl
                                                        );
                                                        that.badgeId.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[0]
                                                                .topicId
                                                        );
                                                        that.badgeLevel.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[0]
                                                                .level
                                                        );
                                                        that.badgeImgUrls[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[0].smallImageUrl;
                                                        that.badgeIds[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[0].topicId;
                                                        that.badgeLevels[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[0].level;
                                                    } else {
                                                        that.badgeIdInfo.push(
                                                            false
                                                        );
                                                        that.badgeIdInfos[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = false;
                                                        that.badgeImgUrl.push(
                                                            "0"
                                                        );
                                                        that.badgeId.push(0);
                                                        that.badgeLevel.push(0);
                                                        that.badgeImgUrls[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = "";
                                                        that.badgeIds[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = "";
                                                        that.badgeLevels[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = "";
                                                    }
                                                } else if (
                                                    data.data.infoList
                                                        .userVirtualAssetInfoLists[
                                                        i
                                                    ].userAssetViewList
                                                        .length == 2
                                                ) {
                                                    if (
                                                        data.data.infoList
                                                            .userVirtualAssetInfoLists[
                                                            i
                                                        ].userAssetViewList[0]
                                                            .type == "badge"
                                                    ) {
                                                        that.badgeIdInfo.push(
                                                            true
                                                        );
                                                        that.badgeIdInfos[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = true;
                                                        that.badgeImgUrl.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[0]
                                                                .smallImageUrl
                                                        );
                                                        that.badgeId.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[0]
                                                                .topicId
                                                        );
                                                        that.badgeLevel.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[0]
                                                                .level
                                                        );
                                                        that.badgeImgUrls[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[0].smallImageUrl;
                                                        that.badgeIds[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[0].topicId;
                                                        that.badgeLevels[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[0].level;
                                                    } else if (
                                                        data.data.infoList
                                                            .userVirtualAssetInfoLists[
                                                            i
                                                        ].userAssetViewList[1]
                                                            .type == "badge"
                                                    ) {
                                                        that.badgeIdInfo.push(
                                                            true
                                                        );
                                                        that.badgeIdInfos[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] = true;
                                                        that.badgeImgUrl.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[1]
                                                                .smallImageUrl
                                                        );
                                                        that.badgeId.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[1]
                                                                .topicId
                                                        );
                                                        that.badgeLevel.push(
                                                            data.data.infoList
                                                                .userVirtualAssetInfoLists[
                                                                i
                                                            ]
                                                                .userAssetViewList[1]
                                                                .level
                                                        );
                                                        that.badgeImgUrls[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[1].smallImageUrl;
                                                        that.badgeIds[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[1].topicId;
                                                        that.badgeLevels[
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userId
                                                        ] =
                                                            data.data.infoList.userVirtualAssetInfoLists[
                                                                i
                                                            ].userAssetViewList[1].level;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                response.listElements.map((item) => {
                                    item.zanStatus = item.currentUserContentRelation
                                        ? item.currentUserContentRelation
                                              .bePraised
                                        : false;
                                    item.caiStatus = item.currentUserContentRelation
                                        ? item.currentUserContentRelation
                                              .beTread
                                        : false;
                                    try {
                                        let replies = item.commentInfo.replies;
                                        if (replies && replies.length > 0) {
                                            replies.map((repliy) => {
                                                repliy.zanStatus = repliy.currentUserContentRelation
                                                    ? repliy
                                                          .currentUserContentRelation
                                                          .bePraised
                                                    : false;
                                                repliy.caiStatus = repliy.currentUserContentRelation
                                                    ? repliy
                                                          .currentUserContentRelation
                                                          .beTread
                                                    : false;
                                            });
                                        }
                                    } catch (err) {}
                                });
                                if (sort) {
                                    // that.GetCommentsList = [];
                                    that.GetCommentsList =
                                        response.listElements;
                                } else {
                                    let listElements = response.listElements.filter(
                                        (obj) =>
                                            !that.GetCommentsList.some(
                                                (commentsList) =>
                                                    commentsList.id == obj.id
                                            )
                                    );
                                    that.GetCommentsList = that.GetCommentsList.concat(
                                        listElements
                                    );
                                }
                                that.PageIndex = that.PageIndex + 1;
                                that.isAchiveBottom = false;
                                that.loadType = 3;

                                if (
                                    (response.listElements.length > 1 &&
                                        that.type != "duanPing") ||
                                    (that.type == "duanPing" &&
                                        response.listElements.length >
                                            (this.$utils.browser.isiOS()
                                                ? 1
                                                : 2)) ||
                                    that.type == "pingCe"
                                ) {
                                    that.$nextTick(() => {
                                        that.calculateText(sort);
                                    });
                                } else {
                                    that.loadType = 4;
                                }
                            } else {
                                that.showEnd = true;
                                that.loadType = 4;
                            }
                            that.$nextTick(() => {
                                let avatarFrameList = document.querySelectorAll(
                                    ".Commont-AvatarFrame"
                                );
                                for (
                                    let i = 0;
                                    i < avatarFrameList.length;
                                    i++
                                ) {
                                    let imgList = avatarFrameList[
                                        i
                                    ].getAttribute("data-avatarFrames");

                                    imgList = imgList.split(",");
                                    if (imgList.length > 1) {
                                        that.avatarFrameTimer = setInterval(
                                            () => {
                                                that.handleAvatarFrame();
                                            },
                                            100
                                        );
                                    } else if (imgList.length == 1) {
                                        let imgIndex =
                                            that.avatarFrameIndex %
                                            imgList.length;
                                        avatarFrameList[i].setAttribute(
                                            "style",
                                            "background-image: url(" +
                                                imgList[imgIndex] +
                                                ")"
                                        );
                                    }
                                }
                            });
                        } else {
                            that.loadType = 4;
                        }
                    });
                } else {
                    that.loadType = 4;
                }
            }
        },
        // 切换评论排序
        GetCommentOrder() {
            clearInterval(this.avatarFrameTimer);
            this.badgeIdInfo = [];
            this.badgeImgUrl = [];
            this.badgeId = [];
            this.badgeLevel = [];
            this.avatarFrameTimer = null;
            this.CommentOrder == "tuiJian"
                ? (this.CommentOrder = "faBuShiJianJiangXu")
                : (this.CommentOrder = "tuiJian");
            this.PageIndex = 0;
            this.loadType = 1;
            let domList = document.querySelectorAll(".Commont-Text");
            [].forEach.call(domList, (item) => {
                item.querySelector("div").removeAttribute("isUnfold");
            });
            this.$nextTick(() => {
                this.GetComments(true);
            });
        },
        //  点赞内容(游戏)
        praiseComment(
            commentId,
            e,
            contentUrl = "",
            commentItem,
            commentIndex,
            replyIndex = null
        ) {
            let that = this;
            let dom = e.currentTarget;
            GSAppJsApi.User.loginTo(function(isLoginCompleted) {
                if (isLoginCompleted) {
                    if (!commentItem.zanStatus) {
                        if (dom.parentNode.querySelector(".Commont-cai")) {
                            dom.parentNode.querySelector(
                                ".Commont-cai"
                            ).className = "Commont-cai";
                        }
                        // 二级评论
                        if (typeof replyIndex == "number") {
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex],
                                "zanStatus",
                                true
                            );
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex],
                                "praisesCount",
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex].praisesCount + 1
                            );
                        } else {
                            that.$set(
                                that.GetCommentsList[commentIndex],
                                "zanStatus",
                                true
                            );
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo,
                                "praisesCount",
                                that.GetCommentsList[commentIndex].commentInfo
                                    .praisesCount + 1
                            );
                        }

                        // 新闻点赞
                        /* 
                        /@/comment/praiseComment/6.0.0/用户id
                        */
                        if (that.type == "xinWen") {
                            let Url =
                                `${config.baseUrl}/comment/praiseComment/6.0.0/` +
                                GSAppJsApi.User.getCurrentUserId();
                            that.$ajax
                                .post(Url, {
                                    postUrl: that.$store.state.sourceUrl,
                                    commentId: commentId,
                                })
                                .then((repsonse) => {});
                        } else {
                            // 帖子点赞
                            let Url = `${
                                config.baseUrl
                            }/userData/praiseContent/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                            that.$ajax
                                .get(Url, {
                                    contentUrl: contentUrl,
                                })
                                .then((response) => {});
                        }
                    } else {
                        // 取消点赞 点赞数-1
                        let url = `${
                            config.baseUrl
                        }/comment/cancelPraiseComment/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                        that.$ajax
                            .post(url, {
                                commentId: commentId,
                                postUrl: that.$store.state.sourceUrl,
                            })
                            .then((response) => {
                                if (replyIndex != null && replyIndex > -1) {
                                    that.$set(
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.replies[replyIndex],
                                        "praisesCount",
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.replies[replyIndex]
                                            .praisesCount - 1
                                    );
                                    that.$set(
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.replies[replyIndex],
                                        "zanStatus",
                                        false
                                    );
                                } else {
                                    that.$set(
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo,
                                        "praisesCount",
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.praisesCount - 1
                                    );
                                    that.$set(
                                        that.GetCommentsList[commentIndex],
                                        "zanStatus",
                                        false
                                    );
                                }
                            });
                    }
                }
            });
        },
        // 踩内容 （找游戏）
        treadContent(contentUrl, e) {
            let that = this;
            let dom = e.currentTarget;
            GSAppJsApi.User.loginTo((isLoginCompleted) => {
                if (isLoginCompleted) {
                    let zan = dom.parentNode.querySelector(".Commont-zan");
                    if (zan) {
                        let zanCount = Number(
                            zan.querySelector("span").innerText
                        );
                        if (zan.className.indexOf("cur") != -1) {
                            zan.querySelector("span").innerText =
                                zanCount > 0 ? zanCount - 1 : 0;
                        }
                        zan.className = "Commont-zan";
                    }
                    let ApiUrl = "";
                    if (dom.className.indexOf("cur") == -1) {
                        ApiUrl = `${
                            config.baseUrl
                        }/userData/treadContent/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                        that.$ajax
                            .get(ApiUrl, {
                                contentUrl: contentUrl,
                            })
                            .then((response) => {
                                dom.className.indexOf("cur") == -1
                                    ? dom.classList.add("cur")
                                    : dom.classList.remove("cur");
                            });
                    } else {
                        that.$toast({
                            message: "您已经踩过了",
                        });
                        // ApiUrl = `//router.gamersky.com/@/userData/cancelTreadContent/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                        // 社区氛围优化要求踩可以取消，取消踩后赞保持原状。
                    }
                }
            });
        },
        //  点赞内容
        praiseComment2(
            commentId,
            e,
            contentUrl = "",
            commentItem,
            commentIndex,
            replyIndex = null
        ) {
            let that = this;
            let dom = e.currentTarget;
            GSAppJsApi.User.loginTo(function(isLoginCompleted) {
                if (isLoginCompleted) {
                    if (!commentItem.zanStatus) {
                        // that.$toast({
                        //     message: "点赞成功",
                        //     type: "success"
                        // });
                        if (dom.parentNode.querySelector(".Commont-cai")) {
                            dom.parentNode.querySelector(
                                ".Commont-cai"
                            ).className = "Commont-cai";
                        }
                        // 二级评论
                        if (typeof replyIndex == "number") {
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex],
                                "zanStatus",
                                true
                            );
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex],
                                "praisesCount",
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex].praisesCount + 1
                            );
                        } else {
                            that.$set(
                                that.GetCommentsList[commentIndex],
                                "zanStatus",
                                true
                            );
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo,
                                "praisesCount",
                                that.GetCommentsList[commentIndex].commentInfo
                                    .praisesCount + 1
                            );
                        }

                        // 新闻点赞
                        /* 
						/@/comment/praiseComment/6.0.0/用户id
						*/
                        console.log(that.$store.state.sourceUrl);
                        if (that.type == "xinWen") {
                            let Url =
                                `${config.baseUrl}/comment/praiseComment/6.0.0/` +
                                GSAppJsApi.User.getCurrentUserId();
                            that.$ajax
                                .post(Url, {
                                    postUrl: that.$store.state.sourceUrl,
                                    commentId: commentId,
                                })
                                .then((repsonse) => {});
                        } else {
                            // 帖子点赞
                            let Url = `${
                                config.baseUrl
                            }/userData/praiseContent/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                            that.$ajax
                                .get(Url, {
                                    contentUrl: contentUrl,
                                })
                                .then((response) => {});
                        }
                    } else {
                        // 取消点赞 点赞数-1
                        let url = `${
                            config.baseUrl
                        }/comment/cancelPraiseComment/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
                        that.$ajax
                            .post(url, {
                                commentId: commentId,
                                postUrl: that.$store.state.sourceUrl,
                            })
                            .then((response) => {
                                // that.$toast({
                                //     message: "取消点赞成功",
                                //     type: "success"
                                // });
                                if (replyIndex != null && replyIndex > -1) {
                                    that.$set(
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.replies[replyIndex],
                                        "praisesCount",
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.replies[replyIndex]
                                            .praisesCount - 1
                                    );
                                    that.$set(
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.replies[replyIndex],
                                        "zanStatus",
                                        false
                                    );
                                } else {
                                    that.$set(
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo,
                                        "praisesCount",
                                        that.GetCommentsList[commentIndex]
                                            .commentInfo.praisesCount - 1
                                    );
                                    that.$set(
                                        that.GetCommentsList[commentIndex],
                                        "zanStatus",
                                        false
                                    );
                                }
                            });
                    }
                }
            });
        },
        // 踩评论
        treadComment(
            contentUrl,
            e,
            commentInfo,
            commentIndex,
            replyIndex = null
        ) {
            let that = this;
            let dom = e.currentTarget;
            GSAppJsApi.User.loginTo((isLoginCompleted) => {
                if (isLoginCompleted) {
                    const userId = GSAppJsApi.User.getCurrentUserId();
                    let zan = dom.parentNode.querySelector(".Commont-zan");
                    if (zan) {
                        let zanCount = Number(
                            zan.querySelector("span").innerText
                        );
                        if (zan.className.indexOf("cur") != -1) {
                            // zan.querySelector("span").innerText = zanCount > 0 ? zanCount - 1 : 0;
                            if (replyIndex != null && replyIndex > -1) {
                                this.$set(
                                    that.GetCommentsList[commentIndex]
                                        .commentInfo.replies[replyIndex],
                                    "praisesCount",
                                    zanCount - 1
                                );
                            } else {
                                this.$set(
                                    that.GetCommentsList[commentIndex]
                                        .commentInfo,
                                    "praisesCount",
                                    zanCount - 1
                                );
                            }
                        }
                        zan.className = "Commont-zan";
                        if (replyIndex != null && replyIndex > -1) {
                            that.$set(
                                that.GetCommentsList[commentIndex].commentInfo
                                    .replies[replyIndex],
                                "zanStatus",
                                false
                            );
                        } else {
                            that.$set(
                                that.GetCommentsList[commentIndex],
                                "zanStatus",
                                false
                            );
                        }
                    }
                    let device = "";
                    if (this.$utils.browser.isAndroid()) {
                        device = "App_Android";
                    } else {
                        device = "App_iOS";
                    }
                    let ApiUrl = "";
                    if (dom.className.indexOf("cur") == -1) {
                        ApiUrl = `${config.baseUrl}/comment/treadComment/6.2.0/${userId}/${device}`;
                        that.$ajax
                            .post(ApiUrl, {
                                commentId: commentInfo.id,
                                postUrl: that.$store.state.sourceUrl,
                            })
                            .then((response) => {
                                dom.className.indexOf("cur") == -1
                                    ? dom.classList.add("cur")
                                    : dom.classList.remove("cur");
                            });
                        // this.$toast({
                        //     message: "点踩成功",
                        //     type: "success"
                        // });
                    } else {
                        // 取消踩
                        ApiUrl = `${config.baseUrl}/comment/cancelTreadComment/6.2.0/${userId}/${device}`;
                        that.$ajax
                            .post(ApiUrl, {
                                commentId: commentInfo.id,
                                postUrl: that.$store.state.sourceUrl,
                            })
                            .then((response) => {
                                if (!response.error) {
                                    let cai = dom.parentNode.querySelector(
                                        ".Commont-cai"
                                    );
                                    if (
                                        cai &&
                                        cai.className.indexOf("cur") != -1
                                    ) {
                                        cai.classList.remove("cur");
                                    }
                                }
                                // this.$toast({
                                //     message: "取消点踩成功",
                                //     type: "success"
                                // });
                            });
                    }
                }
            });
        },
       
        // 展开更多操作
        CommentMenu(item) {
            GSAppJsApi.UI.openCommentMenu(item.commentInfo);
        },
        fontNumFunc(text) {
            this.$nextTick(() => {
                let dom = document.querySelector(".Commont-Text");
                let domWidth = dom.clientWidth;
                let fontSize = Number(
                    window.getComputedStyle(dom).fontSize.replace("px", "")
                );
                this.fontNumber = Math.floor((domWidth / fontSize) * 6);
            });
            let div = document.createElement("div");
            div.innerHTML = text;
            text = div.innerText;

            if (text.length > this.fontNumber) {
                return text.substring(0, this.fontNumber);
            } else {
                return text;
            }
        },
        // 展开更多回复
        MoreUnfold(event) {
            let e = event.currentTarget;
            e.innerHTML = "展开更多";
            let replyList = e
                .closest(".Commont-replyBox")
                .querySelectorAll(".Commont-reply");
            let noneCount = 0;
            [].forEach.call(replyList, (item, index) => {
                if (item.style.display == "none" && noneCount < 8) {
                    noneCount++;
                    item.style.display = "block";
                }
                if (
                    item.style.display == "block" &&
                    index == replyList.length - 1
                ) {
                    e.style.display = "none";
                }
            });
        },
        fontToString(str) {
            let div = document.createElement("div");
            div.innerHTML = str;
            return div.innerText;
        },
        // 展开更多内容
        openText(e) {
            let dom = e.currentTarget
                .closest(".Commont-Text")
                .querySelector("div");
            dom.style.height = "auto";
            dom.setAttribute("isUnfold", "true");
            e.currentTarget.closest(".Commont-Unfold").style.display = "none";
        },
        // 替换表情图标
        replaceEmoji(text) {
            _gsEmoji.map(item => {
                let key = item.key.replace("]", "\\]");
                let reg = new RegExp(`\\${key}`, "g");
                text = text.replace(reg, `<img class="emojiIcon" src="${item.imageUrl}">`);
            });
            return text;
        },
        // 跳转个人中心
        PersonalCenterInto(userId) {
            let a = document.createElement("a");
            a.href = `//i.gamersky.com/u/${userId}`;
            a.click();
            a.remove();
        },
        BadgeCenterInto(userid, topicId, badgeLevel) {
            let a = document.createElement("a");
            a.href =
                "http://project-test.gamersky.com/gsbadge/badge.html?topicId=" +
                topicId +
                "&btnShow=" +
                badgeLevel +
                "&userId=" +
                userid +
                "&appnavigationbarstyle=knonebar&appstatusbarstyle=kLightBar&gsAppOpenWithNewWindow=true";
            a.click();
            a.remove();
        },
        // 显示用户第三方平台绑定图标
        showGameTempllate(userData) {
            if (
                userData.playStationAccount &&
                userData.steamAccount &&
                userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "steampsnxbox";
            } else if (
                userData.playStationAccount &&
                userData.steamAccount &&
                !userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "steampsn";
            } else if (
                !userData.playStationAccount &&
                userData.steamAccount &&
                userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "steamxbox";
            } else if (
                userData.playStationAccount &&
                !userData.steamAccount &&
                userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "psnxbox";
            } else if (
                userData.playStationAccount &&
                !userData.steamAccount &&
                !userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "psn";
            } else if (
                !userData.playStationAccount &&
                userData.steamAccount &&
                !userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "steam";
            } else if (
                !userData.playStationAccount &&
                !userData.steamAccount &&
                userData.xboxAccount &&
                !userData.epicAccount
            ) {
                return "xbox";
            } else if (
                userData.playStationAccount &&
                userData.steamAccount &&
                userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "steampsnxboxepic";
            } else if (
                !userData.playStationAccount &&
                userData.steamAccount &&
                userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "steamxboxepic";
            } else if (
                userData.playStationAccount &&
                !userData.steamAccount &&
                userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "psnxboxepic";
            } else if (
                userData.playStationAccount &&
                userData.steamAccount &&
                !userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "steampsnepic";
            } else if (
                !userData.playStationAccount &&
                !userData.steamAccount &&
                userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "xboxepic";
            } else if (
                !userData.playStationAccount &&
                userData.steamAccount &&
                !userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "steamepic";
            } else if (
                userData.playStationAccount &&
                !userData.steamAccount &&
                !userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "psnepic";
            } else if (
                !userData.playStationAccount &&
                !userData.steamAccount &&
                !userData.xboxAccount &&
                userData.epicAccount
            ) {
                return "epic";
            } else {
                return "";
            }
        },
        // App内调起图片查看器
        viewPicture(ImageInfoIndex, event) {
            let parentDom = event.currentTarget.closest(".Commont-ImageInfes");
            GSAppJsApi.UI.openImageBrowser(ImageInfoIndex, function() {
                let imageList = parentDom.querySelectorAll("img");
                let imageInfesList = new Array();
                imageList.forEach((item, index) => {
                    let width = item.offsetWidth;
                    let height = item.offsetHeight;
                    let frame = {
                        x:
                            item.getBoundingClientRect().left +
                            document.documentElement.scrollLeft,
                        y:
                            item.getBoundingClientRect().top +
                            document.documentElement.scrollTop,
                        width: width,
                        height: height,
                    };
                    imageInfesList.push({
                        index: index,
                        thumbnailUrl: item.getAttribute("src"),
                        imageUrl: item.getAttribute("sourceImageUrl"),
                        caption: "",
                        frame: frame,
                    });
                });
                return JSON.stringify(imageInfesList);
            });
        },
        // 添加图片tag
        imageTag(tag) {
            switch (tag) {
                case "长图":
                    return "changtu";
                case "gif":
                    return "gif";
                default:
                    return "";
            }
        },
        // 添加等级图标
        setLevel(Level) {
            let LevelDarkIcons = [
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_0_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_1_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_2_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_3_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_4_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_5_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_6_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_7_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_8_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_20x12_9_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_10_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_11_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_12_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_13_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_14_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_15_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_16_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_17_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_18_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_19_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_20_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_21_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_22_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_23_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_24_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_25_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_26_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_27_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_28_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_29_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_30_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_31_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_32_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_33_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_34_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_35_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_36_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_37_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_38_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_39_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_40_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_41_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_42_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_43_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_44_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_45_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_46_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_47_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_48_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_49_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_50_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_51_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_52_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_53_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_54_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_55_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_56_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_57_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_58_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_59_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_60_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_61_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_62_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_63_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_64_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_65_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_66_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_67_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_68_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_69_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_70_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_71_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_72_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_73_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_74_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_75_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_76_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_77_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_78_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_79_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_80_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_81_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_82_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_83_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_84_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_85_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_86_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_87_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_88_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_89_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_90_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_91_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_92_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_93_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_94_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_95_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_96_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_97_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_98_Dark@3x.png",
                "//image.gamersky.com/app/icons6.0/rank/icon_Level_26x12_99_Dark@3x.png",
            ];
            let IconUrl = LevelDarkIcons[Level];

            return {
                background: `url(${IconUrl}) no-repeat center / ${
                    Level >= 10 ? 26 : 20
                }px 12px`,
                width: `${Level >= 10 ? 26 : 20}px`,
            };
        },
        // 处理标签
        handleLabel() {
            let { GetCommentsList } = this;
            let buttonInfes1 = [],
                buttonInfes2 = [];
            for (let i = 0; i < GetCommentsList.length; i++) {
                if (GetCommentsList[i].type == "biaoQianAnNiuTiao") {
                    let buttonInfes = GetCommentsList[i].buttonInfes;
                    for (let j = 0; j < buttonInfes.length; j++) {
                        if (
                            buttonInfes[j].caption.indexOf("玩过认证") > -1 ||
                            buttonInfes[j].caption.indexOf("好评") > -1 ||
                            buttonInfes[j].caption.indexOf("差评") > -1 ||
                            buttonInfes[j].caption.indexOf("Steam热评") > -1
                        ) {
                            buttonInfes1.push(buttonInfes[j]);
                        } else {
                            buttonInfes2.push(buttonInfes[j]);
                        }
                    }
                }
            }
            this.buttonInfes1 = buttonInfes1;
            this.buttonInfes2 = buttonInfes2;
        },
     
        publishComment(){
            let that = this;
            if(!this.contentInHtml) return false;
            let device = "";
            if (this.$utils.browser.isAndroid()) {
                device = "App_Android";
            } else {
                device = "App_iOS";
            }
                let newComment = {
                   id: 0,
                   type: "comment",
                   imageInfes: null,
                   appName: "客户端",
                   user: GSAppJsApi.User.getCurrentUser(),
            };
            if(this.publishComment != {}) {
                newComment.replyComment = this.replyComment;
                newComment.replyUser = this.replyComment.user;
                newComment.contentInHtml = this.contentInHtml;
            } else {
                newComment.contentInHtml = this.contentInHtml
            }

            GSAppJsApi.Environment.getAppInfo((info)=>{
                newComment.deviceName = info.deviceName;
                 const ApiUrl = `${
                config.baseUrl
            }/comment/publishComment/6.0.0/${GSAppJsApi.User.getCurrentUserId()}/${device}`;
            this.$ajax
                .post(ApiUrl, {
                    contentUrl: this.$store.state.sourceUrl,
                    newComment: newComment,
                })
                .then((res) => {
                    console.log(res);
                    const response = res.newComment;
                    this.contentInHtml = '';
                    this.keyBoardShow = false;
                    if (that.type == "xinWen") {
                        if (
                            !response.replyComment ||
                            response.replyComment.id == 0
                        ) {
                            that.GetCommentsList.splice(1, 0, {
                                commentInfo: response,
                                type: "pingLun",
                            });
                            // document
                            //     .querySelector(".GsAppCompont_Commont")
                            //     .scrollIntoView({ block: "start", behavior: "smooth" });
                            // let newCommentDom = document.querySelector('.Commont-Text');
                            newCommentDom.querySelector("div").style.height =
                                "auto";
                            newCommentDom.querySelector(
                                ".Commont-Unfold"
                            ).style.display = "none";
                        } else {
                            for (
                                let i = 0;
                                i < that.GetCommentsList.length;
                                i++
                            ) {
                                if (
                                    that.GetCommentsList[i].commentInfo &&
                                    that.GetCommentsList[i].commentInfo.id ==
                                        response.replyComment.id
                                ) {
                                    console.log("一级回复");
                                    that.isSecondLevelReply = false;
                                    if (
                                        that.GetCommentsList[i].commentInfo
                                            .replies
                                    ) {
                                        that.GetCommentsList[
                                            i
                                        ].commentInfo.replies.unshift(response);
                                    } else {
                                        that.$set(
                                            that.GetCommentsList[i].commentInfo,
                                            "replies",
                                            []
                                        );
                                        that.GetCommentsList[
                                            i
                                        ].commentInfo.replies.unshift(response);
                                    }
                                    break;
                                }
                            }
                            if (that.isSecondLevelReply) {
                                console.log("二级回复");
                                // that.GetCommentsList[that.commentIndex].commentInfo.replies.unshift(response);
                                if (
                                    that.GetCommentsList[that.commentIndex]
                                        .commentInfo.replies
                                ) {
                                    that.GetCommentsList[
                                        that.commentIndex
                                    ].commentInfo.replies.unshift(response);
                                } else {
                                    that.$set(
                                        that.GetCommentsList[that.commentIndex]
                                            .commentInfo,
                                        "replies",
                                        []
                                    );
                                    that.GetCommentsList[
                                        that.commentIndex
                                    ].commentInfo.replies.unshift(response);
                                }
                            }
                        }
                    }
                });
            })


            
        },
        closeKeyBoardShow(){
        console.log('closeKeyBoardShow')
          this.keyBoardShow = false;
          this.contentInHtml = '';
        }
    },
   
};
</script>
<style lang="scss" scoped>
.GsAppCompont_Commont {
    position: relative;
    margin-top: -1.8rem;
    z-index: 1;
    user-select: none;
    background-color: #000;
    // @include PageCommont_BtnItemBackGround($PageCommont_BtnItemBackGround);
    .the-end {
        width: 100%;
        height: 44px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 112px 12px;
        @include theend($theend);
        margin-top: -24px;
    }
    .the-more {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 44px;
        font-size: 16px;
        text-align: center;
        @include PageAuthorInformation_TitleColor(
            $PageAuthorInformation_TitleColor
        );
        i {
            display: block;
            width: 16px;
            height: 16px;
            margin-right: 4px;
            background-repeat: no-repeat;
            background-size: 16px;
            background-position: center;
            @include commontLoading($commontLoading);
            animation: commontLoading 1s linear infinite;
        }
        @keyframes commontLoading {
            to {
                transform: rotate(360deg);
            }
        }
    }
    .Commont-Wupinglun-pic {
        display: block;
        margin: 20px auto 0;
        width: 200px;
        height: 170px;
        // padding-top: 20px;
        @include Wupinglun($Wupinglun);
        background-size: 200px 170px;
        background-repeat: no-repeat;
        background-position: center;
    }
    .Commont-Wupinglun-text {
        text-align: center;
        font-size: 14px;
        @include PageAuthorInformation_TitleColor(
            $PageAuthorInformation_TitleColor
        );
        padding-bottom: 60px;
    }
    .Commont-WuPingCe-text {
        display: flex;
        align-items: center;
        height: 51px;
        font-size: 14px;
        color: #999;
        padding: $Page_BetweenPadding;
        @include PageAuthorInformation_TitleColor(
            $PageAuthorInformation_TitleColor
        );
        border-bottom: 6px solid;
        @include Recommend_BorderColor($Recommend_BorderColor);
    }
    .Commont-TitleBox {
        display: block;
        height: 64px;
        margin-bottom: 13px;
        position: relative;
        .Commont-sort {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            width: 88px;
            height: 30px;
            @include sort($sort);
            border-radius: 15px;
            overflow: hidden;
            .Commont-sortName {
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1;
                height: 30px;
                font-size: 12px;
                color: #666;
            }
            .Commont-sortCur {
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 50%;
                left: 0;
                transform: translate(0, -50%);
                width: 44px;
                height: 28px;
                border-radius: 15px;
                border: 1px solid;
                @include sortBorder($sortBorder);

                box-sizing: border-box;
                @include sortCur($sortCur);
                @include PageTitleBar_color($PageTitleBar_color);
                font-size: 12px;
                font-family: "黑体";
                transition: all 0.2s;
                &.cur {
                    transform: translate(44px, -50%);
                }
            }
        }
        .Commont-title {
            padding: $Page_BetweenPadding;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: bold;
            @include PageCommont_TitleColor($PageCommont_TitleColor);
            height: 64px;
            box-sizing: border-box;
        }
    }
    .Commont-Review-btnWrap {
        margin: 0 auto 24px;
        .Commont-Review-btnBox {
            width: 100%;
            box-sizing: border-box;
            &:last-child {
                margin-top: 8px;
            }
            .Commont-Review-btnList {
                // height: 28px;
                width: 100%;
                padding: $Page_BetweenPadding;
                font-size: 0px;
                margin-bottom: -8px;
                margin-right: -8px;
                // overflow-x: auto;
                // overflow-y: hidden;
                // white-space: nowrap;
                // -webkit-overflow-scrolling: touch;
                &::-webkit-scrollbar {
                    display: none;
                }
                .Commont-Review-btnItem {
                    display: inline-block;
                    padding: 0 12px;
                    height: 100%;
                    line-height: 28px;
                    text-align: center;
                    font-size: 12px;
                    @include PageCommont_BtnItemColor(
                        $PageCommont_BtnItemColor
                    );
                    @include PageCommont_BtnItemBackGround(
                        $PageCommont_BtnItemBackGround
                    );
                    // color: #222;
                    // background: #f5f7f9;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    border-radius: 2px;
                    overflow: hidden;
                }
            }
        }
    }

    .Commont-detailBox {
        padding: $Page_BetweenPadding;
        margin-bottom: 24px;
        overflow: visible;
        &:last-child {
            margin-bottom: 0;
        }
        .Commont-Top {
            position: relative;
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            overflow: visible;
            .Commont-HeadImage {
                width: 34px;
                height: 34px;
                margin-right: 12px;
                position: relative;
                overflow: visible;
                flex-shrink: 0;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    overflow: hidden;
                }
                .Commont-AvatarFrame {
                    position: absolute;
                    left: -9px;
                    top: -9px;
                    width: 52px;
                    height: 52px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 52px;
                }
                img.Commont-HeadImage-vip {
                    display: block;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 14px;
                    height: 14px;
                }
                .Commont-NotHeadImage {
                    width: 100%;
                    height: 100%;
                    background: #ccc
                        url("//image.gamersky.com/app/icons6.0/DefaultHeadImage.png")
                        no-repeat center / 100%;
                    border-radius: 50%;
                    overflow: hidden;
                }
                i {
                    display: block;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 14px;
                    height: 14px;
                    background: url("//image.gamersky.com/app/icons6.0/icon_UserAuthenticationIcon_Blue_12x12@3x.png")
                        no-repeat center / 14px;
                }
            }
            .Commont-more {
                position: absolute;
                right: 0;
                top: 4px;
                display: block;
                width: 16px;
                height: 16px;
                background-size: 16px;
                background-repeat: no-repeat;
                background-position: center;
                @include More($More);
                cursor: pointer;
            }
        }

        .Commont-Title {
            font-size: 15px;
            @include PageTitleBar_color($PageTitleBar_color);
            font-weight: bold;
            margin-bottom: 4px;
            line-height: 20px;
        }

        .Commont-Information {
            display: flex;
            flex: 1;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            .Commont-InformationBox {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
                &span,
                &i {
                    display: block;
                }
                .Commont-Name {
                    font-size: 14px;
                    font-weight: bold;
                    @include PageCommont_NameColor($PageCommont_NameColor);
                    margin-right: 5px;
                    line-height: 20px;
                    span {
                        font-size: 14px;
                        font-weight: bold;
                        @include PageCommont_NameColor($PageCommont_NameColor);
                    }
                    &.HongMing {
                        color: #f3a621;
                    }
                }
                .Commont-GameTemplate {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    margin-right: 5px;
                    &.steampsnxbox {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steampsnxbox.svg")
                            no-repeat center / 16px;
                    }
                    &.steampsn {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steampsn.svg")
                            no-repeat center / 16px;
                    }
                    &.steamxbox {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steamxbox.svg")
                            no-repeat center / 16px;
                    }
                    &.psnxbox {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-psnxbox.svg")
                            no-repeat center / 16px;
                    }
                    &.psn {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-psn.svg")
                            no-repeat center / 16px;
                    }
                    &.steam {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steam.svg")
                            no-repeat center / 16px;
                    }
                    &.xbox {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-xbox.svg")
                            no-repeat center / 16px;
                    }

                    &.steampsnxboxepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steampsnxboxepic.svg")
                            no-repeat center / 16px;
                    }
                    &.steamxboxepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steamxboxepic.svg")
                            no-repeat center / 16px;
                    }
                    &.psnxboxepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-psnxboxepic.svg")
                            no-repeat center / 16px;
                    }
                    &.steampsnepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steampsnepic.svg")
                            no-repeat center / 16px;
                    }
                    &.xboxepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-xboxepic.svg")
                            no-repeat center / 16px;
                    }
                    &.steamepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-steamepic.svg")
                            no-repeat center / 16px;
                    }
                    &.psnepic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-psnepic.svg")
                            no-repeat center / 16px;
                    }
                    &.epic {
                        background: url("//image.gamersky.com/webimg15/user/club2/pc/gamept-epic.svg")
                            no-repeat center / 16px;
                    }
                }
                .Commont-isRealPlayer {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                    background: url("//image.gamersky.com/app/icons6.0/isRealPlayer.png")
                        no-repeat center / 16px;
                }
                .Commont-badge {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                .Commont-Level {
                    display: block;
                    height: 12px;
                    border-radius: 2px;
                    overflow: hidden;
                }
                .Commont-floor {
                    font-size: 12px;
                    @include PageCommont_FloorColor($PageCommont_FloorColor);
                }
            }
            .Commont-Fraction {
                width: auto;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                height: 13px;
                margin-top: 3px;
                .Commont-FractionBox {
                    height: 100%;
                    width: 54px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: auto 10px;
                    @include Stars($Stars);
                    // background: url("//image.gamersky.com/app/icons6.0/icon_Stars_Gray_54x10@3x.png") no-repeat 0 center / auto 10px;
                    margin-right: 5px;
                    div {
                        height: 100%;
                        background-position: 0 center;
                        background-repeat: no-repeat;
                        background-size: auto 10px;
                        @include StarsRi($StarsRi);
                        &.star0 {
                            width: 0px;
                        }
                        &.star1 {
                            width: 20%;
                        }
                        &.star2 {
                            width: 40%;
                        }
                        &.star3 {
                            width: 60%;
                        }
                        &.star4 {
                            width: 80%;
                        }
                        &.star5 {
                            width: 100%;
                        }
                    }
                }
                span {
                    font-size: 10px;
                    color: #999;
                    margin-right: 8px;
                }
                .commentInfo {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    @include PageCommont_TimeColor($PageCommont_TimeColor);
                }
            }
        }
        .Commont-detail {
            box-sizing: border-box;
            .Commont-Text {
                position: relative;
                font-size: 14px;
                line-height: 20px;
                @include PageCommont_TextColor($PageCommont_TextColor);
                text-align: justify;
                margin-bottom: 16px;
                overflow: hidden;
                cursor: pointer;
                &:last-of-type {
                    margin-bottom: 0;
                }
                div {
                    overflow: hidden;
                }
                .Commont-Unfold {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    font-size: 14px;
                    @include zhankai_bgColor($zhankai_bgColor);
                    padding-left: 5px;
                    @include PageCommont_TextColor($PageCommont_TextColor);
                    a {
                        @include PageCommont_TimeColor($PageCommont_TimeColor);
                    }
                }
            }
            .Commont-ImageInfes {
                // 用于3张以上图片时，图片的可点击区域和文字一致。
                .Commont-ImageInfesFrame {
                    display: flex;
                    flex-wrap: wrap;
                    &.CommentStyle {
                        // max-width: 255px;
                        margin-bottom: 4px;
                    }
                    //       img {
                    //             width: 33%;
                    // padding-top: 33%;
                    // height: 0;
                    // background: url('https://img1.gamersky.com/upimg/users/2022/03/17/tiny_202203170427312581.jpg') no-repeat center / auto 100%;
                    //       }
                }

                .Commont-ImageInfes-Item {
                    width: calc((100% - 9px) / 3);
                    // width: 112px;
                    height: 120px;

                    @media (max-width: 375px) {
                        // width: 105px;
                        height: 105px;
                    }

                    position: relative;
                    border-radius: 3px;
                    margin-right: 4px;
                    margin-bottom: 4px;
                    overflow: hidden;
                    cursor: pointer;
                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    i {
                        position: absolute;
                        right: 4px;
                        bottom: 4px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 30px;
                        height: 16px;
                        font-size: 10px;
                        // background: rgba(78, 147, 192, 0.6);
                        // color: rgba($color: #ffffff, $alpha: 0.8);
                        border-radius: 3px;
                        overflow: hidden;
                        font-style: normal;
                        &.changtu {
                            background: url("//image.gamersky.com/app/icons6.0/icon_TagChangTu.png")
                                no-repeat center / 30px 16px;
                        }
                        &.gif {
                            background: url("//image.gamersky.com/app/icons6.0/icon_TagGif.png")
                                no-repeat center / 30px 16px;
                        }
                    }
                }
                &.Commont-TieZi {
                    display: inline-flex;
                    max-width: 100%;
                    flex-wrap: nowrap;
                    // justify-content: space-between;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    margin-bottom: 17px;
                    .Commont-ImageInfes-Length {
                        position: absolute;
                        right: 0;
                        top: 0;
                        margin: 0;
                        padding: 0 4px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 18px;
                        font-size: 10px;
                        color: #fff;
                        background: rgba($color: #000000, $alpha: 0.7);
                        overflow: hidden;
                        border-top-right-radius: 6px;
                        border-bottom-left-radius: 6px;
                        z-index: 2;
                    }
                    .Commont-ImageInfes-Item {
                        width: calc((100% - 9px) / 3);
                        // width: 112px;
                        height: 120px;

                        @media (max-width: 375px) {
                            // width: 105px;
                            height: 105px;
                        }

                        margin-right: 3px;
                        margin-bottom: 0;
                        border-radius: 0;
                        &:last-of-type {
                            margin-right: 0;
                        }
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
            .Commont-VideoInfes {
                position: relative;
                width: 100%;
                height: 158px;
                margin-bottom: 16px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 6px;
                }
                i {
                    display: block;
                    width: 48px;
                    height: 48px;
                    position: absolute;
                    left: 50%;
                    top: 55px;
                    transform: translateX(-50%);
                    background: url("//image.gamersky.com/app/icons6.0/icon_Play_48x48@3x.png")
                        no-repeat center / 48px;
                }
            }
            .Commont-Footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;
                .Commont-Footer-Left {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #999;
                    line-height: 18px;
                }
                .Commont-Footer-Right {
                    display: flex;
                    align-items: flex-end;
                    justify-content: flex-end;
                    span {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        @include PageCommont_ZanColor($PageCommont_ZanColor);
                        margin-right: 32px;
                        line-height: 1;
                        &:last-of-type {
                            margin-right: 0;
                        }
                    }
                    .Commont-Time {
                        font-size: 11px;
                        @include PageCommont_TimeColor($PageCommont_TimeColor);
                    }
                    .Commont-replies {
                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: url("//image.gamersky.com/app/icons6.0/icon-UGC@2x.png")
                                no-repeat center / 16px;
                            margin-right: 4px;
                        }
                    }
                    .Commont-zan {
                        span {
                            line-height: 1;
                        }
                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: url("//image.gamersky.com/app/icons6.0/icon_GameComment_Praise_16x16@3x.png")
                                no-repeat center / 16px;
                            margin-right: 4px;
                            margin-left: 0;
                        }
                        &.cur {
                            i {
                                background: url("//image.gamersky.com/app/icons6.0/icon_GameComment_Praised_16x16@3x.png")
                                    no-repeat center / 16px;
                            }
                        }
                    }
                    .Commont-cai {
                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: url("//image.gamersky.com/app/icons6.0/icon_cai.png")
                                no-repeat center / 16px;
                            margin-right: 4px;
                        }
                        &.cur {
                            i {
                                background: url("//image.gamersky.com/app/icons6.0/icon_cai_cur.png")
                                    no-repeat center / 16px;
                            }
                        }
                    }
                }
            }
            .Commont-replyBox {
                margin-bottom: 10px;
                &:last-of-type {
                    margin-bottom: 0;
                }
                .Commont-reply {
                    // padding: 12px;
                    box-sizing: border-box;
                    // @include PageCommont_ReplyBackGround($PageCommont_ReplyBackGround);
                    position: relative;
                    margin-bottom: 16px;
                    &:last-of-type {
                        margin-bottom: 0;
                    }
                    .Commont-Information {
                        flex-direction: initial;
                        margin-bottom: 8px;
                        .Commont-HeadImage {
                            width: 20px;
                            height: 20px;
                            margin-right: 8px;
                            img {
                                display: block;
                                width: 20px;
                                height: 20px;
                                border-radius: 50%;
                                overflow: hidden;
                                object-fit: cover;
                            }
                        }
                        .Commont-InformationBox {
                            flex: 1;
                            flex-direction: column;
                            align-items: flex-start;
                            justify-content: center;
                            span {
                                font-size: 10px;
                                color: #999;
                                @include PageCommont_TimeColor(
                                    $PageCommont_TimeColor
                                );
                                margin-bottom: 3px;
                                &.Commont-Name {
                                    margin: 0 4px 4px 0;
                                    width: 100%;
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    font-size: 14px;
                                    font-weight: bold;
                                    @include PageCommont_NameColor(
                                        $PageCommont_NameColor
                                    );
                                    span {
                                        font-size: 14px;
                                        font-weight: bold;
                                        @include PageCommont_NameColor(
                                            $PageCommont_NameColor
                                        );
                                    }
                                    i {
                                        color: #999;
                                        font-size: 10px;
                                        margin: 0 4px 0 0;
                                    }
                                    .gamersky {
                                        font-family: "gamersky" !important;
                                    }
                                    .triggle {
                                        margin-right: -2px;
                                        width: 0px;
                                        height: 0px;
                                        border: 6px solid #999;
                                        border-left: 10px solid #999;
                                        border-top-color: transparent;
                                        border-bottom-color: transparent;
                                        border-left-color: #999;
                                        border-right-color: transparent;
                                    }
                                }
                            }
                        }
                    }
                    .Commont-Text {
                        padding-left: 28px;
                    }
                    .Commont-Footer {
                        margin: 0;
                    }
                }
                .Commont-MoreUnfold {
                    display: block;
                    margin-top: -4px;
                    font-size: 14px;
                    color: #5485bd;
                    line-height: 22px;
                    padding-left: 28px;
                    i {
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        background: url("//image.gamersky.com/app/icons6.0/icon_SurfaceArrowDown.png")
                            no-repeat center / 10px;
                        vertical-align: middle;
                    }
                }
            }
        }
        .author_praised {
            margin-top: 8px;
            display: block;
            width: 48px;
            border-radius: 4px;
            font-size: 10px;
            line-height: 20px;
            text-align: center;
            @include PageAuthorInformation_ButtonBackgroundCur(
                $PageAuthorInformation_ButtonBackgroundCur
            );
            @include PageShare_Color($PageShare_Color);
        }
    }
    .Commont-options {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .Commont-zan {
            display: flex;
            align-items: flex-end;
            font-size: 12px;
            span {
                line-height: 1;
            }
            @include PageCommont_ZanColor($PageCommont_ZanColor);
            i {
                margin-right: 4px;
                display: block;
                width: 16px;
                height: 16px;
                @include PingLunDianZan($PingLunDianZan);
                background-position: center;
                background-repeat: no-repeat;
                background-size: 16px;
                margin-right: 4px;
            }
            &.cur {
                color: rgb(235, 65, 61);
                i {
                    background: url("//image.gamersky.com/app/icons6.0/icon_PingLunDianZan_Red.png")
                        no-repeat center / 16px;
                }
            }
        }

        .Commont-cai {
            margin-left: 12px;
            padding-top: 4px;
            display: flex;
            align-items: flex-end;
            font-size: 12px;
            i {
                display: block;
                width: 16px;
                height: 16px;
                margin-right: 4px;
                @include PingLunDianCai($PingLunDianCai);
                background-position: center;
                background-repeat: no-repeat;
                background-size: 16px;
            }
            &.cur {
                i {
                    background: url("//image.gamersky.com/app/icons6.0/icon_PingLunDianCai_Red.png")
                        no-repeat center / 16px;
                }
            }
        }
    }
    .Commont-desc {
        white-space: pre-wrap;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        &.blocked_user_comment {
            @include PageAuthorInformation_TitleColor(
                $PageAuthorInformation_TitleColor
            );
        }
    }
    .pingCeText {
        -webkit-line-clamp: 3;
    }
}
.author_praised {
    margin-top: 8px;
    display: block;
    width: 48px;
    background: #f5f7f9;
    border-radius: 4px;
    font-size: 10px;
    color: #666;
    text-align: center;
    line-height: 20px;
}
.gs-ellipsis2 {
    margin-bottom: 0 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: -webkit-baseline-middle;
}
.gs-ellipsis {
    margin: 0 4px 0 0 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: -webkit-baseline-middle;
}
.publish-commont {
    display: flex;
    align-items: center;
    position: fixed;
    background: #000;
    bottom: 0;
    left: 0;
    right: 0;
    height: 83px;
    padding: 9px 16px;
    box-sizing: border-box;
    z-index: 1;
    .input-box {
        background: #2e2e33;
        width: calc(100% - 40px);
        height: 32px;
        border-radius: 16px;
        padding-left: 10px;
        box-sizing: border-box;
        color: #717173;
        line-height: 32px;
    }
    .input-box-ios {
        width: 100% !important;
    }

}
</style>
